package dev.mft.website.classes

import org.jetbrains.compose.resources.DrawableResource

data class Social(
    val resourceId: DrawableResource,
    val contentDescription: String,
    val url: String
)
